//
// Module for the Notes control
//

rs.module("controls/notes",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "controls/data/grid"
    ],

    function (selectHelper, eventBanner, gridModule) {

        var _executeSelectionChanged;
        var _persistEventBanner;
        var _onNoteSavedCallbacks = [];

        function initialize(jsSelectors, backendUrls, constants, lrsGridApi) {

            // initialize selectors
            var form = $.js(jsSelectors.form);

            var includeExpiredNotes = form.js(jsSelectors.includeExpiredNotes, { required: false });
            var loadingSpinner = form.js(jsSelectors.loadingSpinner, { required: false });
            var addLink = form.js(jsSelectors.addLink);

            var type = form.js(jsSelectors.type, { multiple: true });
            var subject = form.js(jsSelectors.subject, { multiple: true });
            var note = form.js(jsSelectors.note);
            var terminationDate = form.js(jsSelectors.terminationDate, { multiple: true });
            var saveButton = form.js(jsSelectors.saveButton);
            var cancelButton = form.js(jsSelectors.cancelButton);

            var unidocAssocKey = form.js(jsSelectors.unidocAssocKey);
            var unidocKey = form.js(jsSelectors.unidocKey);
            var effectiveDate = form.js(jsSelectors.effectiveDate);
            var enteredDate = form.js(jsSelectors.enteredDate);
            var enteredBy = form.js(jsSelectors.enteredBy);
            var enteredByName = form.js(jsSelectors.enteredByName);
            var updateToken = form.js(jsSelectors.updateToken);

            // initialize select helper
            var typeSelectHelper = selectHelper.getHelper(type);

            // include expired notes change handler - reload grid
            includeExpiredNotes.change(_reloadNotesGrid);

            // notes grid selection change handler - populate selected note details
            lrsGridApi.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    // typically when selecting a new grid row, we would always to clear errors/event banner
                    //
                    // however, grid selection changed will automatically fire after some ajax actions (e.g., a row was saved, the grid reloads, which in turn fires the event)
                    // those ajax actions can set _persistEventBanner = true to prevent their success confirmation message from being prematurely cleared
                    if (!_persistEventBanner) {
                        _clearErrors();
                    }
                    else {

                        // after persisting, now set _persistEventBanner = false to allow typical grid row selection to clear errors
                        _persistEventBanner = false;
                    }

                    $.get(
                        backendUrls.getNote,
                        {
                            unidocAssocKey: values[0]
                        }
                    )
                    .done(function (results) {

                        // populate input fields
                        typeSelectHelper.setValue(results.uniDocSubType?.key);
                        subject.val(results.description);
                        note.val(results.uniDocText);
                        terminationDate.val(results.terminationDate ? new Date(results.terminationDate).toISODateString() : null);

                        // populate hidden inputs
                        unidocAssocKey.val(results.uniDocAssocKey);
                        unidocKey.val(results.uniDocKey);
                        effectiveDate.val(results.effectiveDate);
                        enteredDate.val(results.enteredDate);
                        enteredBy.val(results.enteredBy);
                        enteredByName.val(results.enteredByName);
                        updateToken.val(results.updateToken);
                    });
                }

                _executeSelectionChanged = true;
            });

            // add link click handler - reset notes grid selection and form values
            addLink.click(function () {

                lrsGridApi.selectedValues = null;

                _resetForm();
                _clearErrors();
            });

            // save button click handler - save note and reload grid
            saveButton.click(function () {

                _clearErrors();

                if (form.valid()) {

                    loadingSpinner.show();

                    // save the note
                    $.ajax({
                        type: "POST",
                        url: backendUrls.saveNote,
                        data: {
                            unidocAssocKey: unidocAssocKey.val(),
                            unidocKey: unidocKey.val(),
                            unidocSubType: type.val(),
                            description: subject.val(),
                            unidocText: note.val(),
                            effectiveDate: effectiveDate.val(),
                            terminationDate: terminationDate.val(),
                            enteredDate: enteredDate.val(),
                            enteredBy: enteredBy.val(),
                            enteredByName: enteredByName.val(),
                            updateToken: updateToken.val()
                        },
                        dataType: "text"
                    })
                    .showFieldErrors()
                    .done(function () {

                        var displayType = constants.displayAsComments ? "comment" : "note";
                        eventBanner.addInformationalMessages("The " + displayType + " has been saved.");
                        _persistEventBanner = true;

                        _reloadNotesGrid(function () {

                            // execute each note saved callback that has been registered
                            _onNoteSavedCallbacks.forEach(function (callback) {
                                callback.call(null, lrsGridApi.agGridApi.getDisplayedRowCount());
                            });
                        });
                    })
                    .always(function () {
                        loadingSpinner.hide();
                    });
                }
            });

            // cancel button click handler - reset form values to unmodified state
            cancelButton.click(function () {

                // update mode
                if (unidocAssocKey.val() != -1) {

                    _clearErrors();

                    // Re-retrieve the note
                    $.get(
                        backendUrls.getNote,
                        {
                            unidocAssocKey: unidocAssocKey.val()
                        }
                    )
                    .done(function (results) {

                        // populate input fields
                        typeSelectHelper.setValue(results.uniDocSubType.key);
                        subject.val(results.description);
                        note.val(results.uniDocText);

                        terminationDate.val(results.terminationDate ? new Date(results.terminationDate).toISODateString() : null);

                        // populate hidden inputs
                        unidocAssocKey.val(results.uniDocAssocKey);
                        unidocKey.val(results.uniDocKey);
                        effectiveDate.val(results.effectiveDate);
                        enteredDate.val(results.enteredDate);
                        enteredBy.val(results.enteredBy);
                        enteredByName.val(results.enteredByName);
                        updateToken.val(results.updateToken);
                    });
                }

                // insert mode
                else {

                    _resetForm();
                    _clearErrors();

                    lrsGridApi.selectFirstRow();
                }
            });

            // reload notes grid via ajax
            function _reloadNotesGrid(onGridReload) {

                loadingSpinner.show();

                gridModule.update(
                    backendUrls.getNotesList,
                    {
                        includeExpiredNotes: includeExpiredNotes.is(":checked"),
                        displayAsComments: constants.displayAsComments
                    },
                    lrsGridApi.agGridApi,
                    function done() {

                        if (lrsGridApi.agGridApi.getDisplayedRowCount() > 0) {

                            // select top row if no previous selection
                            if (lrsGridApi.selectedValues.length == 0) {
                                lrsGridApi.selectFirstRow();
                            }
                        }
                        else {
                            _resetForm();
                            _clearErrors();
                        }

                        // Execute supplied callback functions after grid is reloaded.
                        onGridReload();
                    }
                )
                .always(function () {
                    loadingSpinner.hide();
                });
            }

            // reset form inputs and hidden fields
            function _resetForm() {

                // reset input fields
                typeSelectHelper.setValue(constants.defaultNoteType);
                subject.val(null);
                note.val(null);
                terminationDate.val(null);

                // reset hidden inputs
                unidocAssocKey.val(-1);
                unidocKey.val(-1);
                effectiveDate.val(null);
                enteredDate.val(null);
                enteredBy.val(0);
                enteredByName.val(null);
                updateToken.val(null);
            }

            // clear event banner and field errors
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();

                // clear field errors
                type.clearErrors();
                subject.clearErrors();
                note.clearErrors();
                terminationDate.clearErrors();
            }

            //
            // API function to allow consumers to provide a callback to execute when a note is updated
            //
            function onNoteSaved(onNoteSaved) {
                _onNoteSavedCallbacks.push(onNoteSaved);
            }

            // create the instance API and return it
            var instanceApi = {
                onNoteSaved
            };

            return instanceApi;
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);